// @mui
import { Box, Typography, Stack } from '@mui/material';
// assets
import iconImage from '../../images/image-icon.png';



// ----------------------------------------------------------------------

export default function BlockContent() {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      justifyContent="center"
      direction={{ xs: 'column', md: 'row' }}
      sx={{ width: 1, textAlign: { xs: 'center', md: 'left' } }}
    >
      
      <img src={iconImage} alt="RecommendationsImage" sx={{ width: 100, height:100 }}  />
      <Box sx={{ p: 3 }}>
        {/* <Typography gutterBottom variant="h5">
          Browse or Drag & Drop Image Files
        </Typography> */}

        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
         + Add Slider Images (Max 5)<br />
          1900 * 600 Pixels
        </Typography>
      </Box>
    </Stack>
  );
}
